import $api from "@/frontend/shared/api/axios";
import { TSimilarCompaniesResponse } from "./types/types";
import { SimilarCompaniesResponseSchema } from "@/libs/models/companies";

export async function getExpertCompanySimilarCompanies({
  organizationId,
  portfolioCompanyId
}: {
  organizationId: number;
  portfolioCompanyId: number;
}) {
  const response = await $api.get<{ data: TSimilarCompaniesResponse }>(
    `/experts/organizations/${organizationId}/portfolio-companies/${portfolioCompanyId}/similar-companies`
  );
  const parsed = SimilarCompaniesResponseSchema.parse(response.data.data);
  return response.data.data;
}
